import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const NoPagesIcon: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 120 125">
    <svg fill="none">
      <path
        d="M104.86 46.335a3.826 3.826 0 003.824-3.828 3.826 3.826 0 00-3.824-3.828 3.826 3.826 0 00-3.825 3.828 3.826 3.826 0 003.825 3.828zM3.266 67.036a2.517 2.517 0 002.516-2.519 2.517 2.517 0 10-2.516 2.519zM14.833 112.312a2.518 2.518 0 000-5.037 2.518 2.518 0 00-2.517 2.519 2.517 2.517 0 002.517 2.518z"
        fill="#EAEEF9"
      />
      <path
        d="M28.283 112.312l35.31-11.064V55.887l-35.31 10.978v45.447z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M98.9 112.312l-35.308-11.064V55.887L98.9 66.865v45.447z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M63.592 123.461l-35.309-11.064V67.035L63.593 78.1v45.362z"
        fill="#fff"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M63.592 123.461L98.9 112.397V67.035L63.59 78.1v45.362z"
        fill="#fff"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M63.592 55.886L46.99 43.462l-35.9 12.085 17.192 11.32 35.309-10.98z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M63.592 55.886l16.6-12.425 35.9 12.085-17.191 11.32-35.31-10.98zM28.283 67.035L63.592 78.1 45.979 89.333 11.092 77.759l17.19-10.724zM98.9 67.035L63.593 78.1l17.612 11.234 34.888-11.574-17.191-10.724z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M73.443 12.338c4.947 13.425 6.421 16.408 6.905 29.636-.186 3.02-.301 6.303-1.725 8.946-1.901 4.045-6.551 6.846-10.944 6.891-4.526.081-8.963-2.69-10.96-6.963-1.406-2.593-1.36-6.14.566-8.495 2.096-2.259 5.782-2.822 8.434-1.41 2.917 1.34 4.658 4.126 5.303 7.064.644 2.938.361 6.125-.426 9.023-1.646 7.047-3.01 7.388-7.047 19.32"
        stroke="#C9D4E2"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeDasharray="4 4"
      />
      <path
        d="M79.463 5.232c-.012 1.974-1.849 3.183-4.178 2.552-2.453-.418-4.189-.849-4.3-2.61.055-1.807 2.027-2.514 4.334-3.312 2.767-1.099 3.987 1.441 4.144 3.37zM63.614 11.269c1.243 1.28 3.864 1.653 5.14-.302 1.401-2.167 2.6-3.742 1.312-5.189-1.243-1.28-2.453-.418-5.22.681-2.217 1.132-2.688 3.408-1.232 4.81z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M69.35 3.104c1.13-.482 2.486-.129 3.09.784.258.29.56.746.65 1.08.962 2.251.66 4.482-.64 5.01-1.422.739-3.382-.528-4.132-2.656l-.403-1.505c-.145-1.215.303-2.231 1.434-2.713 0 0 .168-.045 0 0z"
        fill="#F1F3F9"
      />
      <path
        d="M69.35 3.104c1.13-.482 2.486-.129 3.09.784.258.29.56.746.65 1.08.962 2.251.66 4.482-.64 5.01-1.422.739-3.382-.528-4.132-2.656l-.403-1.505c-.145-1.215.303-2.231 1.434-2.713zm0 0s.167-.045 0 0z"
        stroke="#D6DCE8"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinejoin="round"
      />
      <path
        d="M17.35 39.332h-2.191v-2.19h-1.877v2.19h-2.19v1.94h2.19v2.19h1.877v-2.19h2.19v-1.94zM22.16 94.279h-2.19v-2.19h-1.878v2.19h-2.19v1.94h2.19v2.19h1.878v-2.19h2.19v-1.94zM117.897 94.402l-2.68-1.353 1.353-2.68-2.297-1.159-1.353 2.68-2.679-1.353-1.198 2.373 2.679 1.353-1.353 2.68 2.297 1.16 1.353-2.68 2.679 1.353 1.199-2.374z"
        fill="#AAB2C5"
      />
    </svg>
  </SvgIcon>
);

export default NoPagesIcon;
